import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
  OnChanges,
  SimpleChanges,
  ViewChild,
  ElementRef,
  AfterViewInit,
  ViewContainerRef,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { VehicleHistoryDrawerData } from '../../models/vehicle-history-drawer.model';
import { ManagerContentVehicleHistoryDrawerService } from '../../services/manager-content-vehicle-history-drawer.service';
import { StateHistoryCardsService } from '../../services/state-history-cards.service';
import {
  AsideHistoryCard,
  AsideType,
  DropdownOption,
  HistoryCard,
  SettingsHistoryDrawer,
} from './models/content-vehicle-history-drawer.model';
import {
  maxRangeDaysValidator,
  notOlderThanNDaysValidator,
  startBeforeOrEqualEndValidator,
} from '../../helpers/custom-validator-history.helper';
import { Observable, Subject, of, timer } from 'rxjs';
import {
  filter,
  takeUntil,
  tap,
  map,
  distinctUntilChanged,
  debounceTime,
  switchMap,
  mapTo,
} from 'rxjs/operators';
import { Unit } from 'src/app/units/models/unit';
import { adapStoreHistoriesToDropdownOptions } from './adapters/adapt-to-storyHistory-from-dropdownOption.adapter';
import { adaptHistoryCard } from './adapters/adapt-historyCard.adapter';
import { LeafletMapService } from 'src/app/map/services/leaflet-map.service';
import {
  DataCircularGeofenceHistory,
  DataGeofenceHistory,
  DataGeopointHistory,
  DetailsHistory,
  EventData,
  FrameHistoryAdapted,
  Stop,
  StoreHistory,
} from '../../models/manager-content-vehicle-history-drawer.model';
import { MenuItem } from 'primeng-lts/api';
import {
  formatDateOnly,
  formatDateTrackerDate,
  formatDateTrackerTime,
  formatMessageToastHistory,
  formatTimeOnly,
} from './helpers/format-dates.helper';
import { idEndFrame, idStartFrame } from './static/ids-cards.static';
import { convertSecondsToTimeString } from 'src/app/vehicles/components/content-panel-vehicles/helpers/convert-seconds-to-time-string';
import * as L from 'leaflet';
import { CircularGeofencesService } from 'src/app/geofences/services/circular-geofences.service';
import { GeopointsService } from 'src/app/geopoints/services/geopoints.service';
import { GeofencesService } from 'src/app/geofences/services/geofences.service';
import { animatePolylineDecorator } from 'src/app/map/helpers/animate-polyline-decorator.helper';
import { DEFAULT_OPTIONS } from 'src/app/map/helpers/create-polyline-decorator.helper';
import { ControllerPolylineDecorator } from 'src/app/map/models/manager-leaflet.model';
import { StateSettingsHistoryDrawerService } from 'src/app/profile-config/user-config/components/user-history-drawer/service/state-settings-history-drawer.service';

import { HistorialService } from '../../services/historial.service';

@Component({
  selector: 'app-content-vehicle-history-drawer',
  templateUrl: './content-vehicle-history-drawer.component.html',
  styleUrls: ['./content-vehicle-history-drawer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentVehicleHistoryDrawerComponent
  implements OnDestroy, OnChanges, AfterViewInit, OnInit
{
  @Input() dataHistoryDrawer: VehicleHistoryDrawerData = {
    variant: 'custom',
    imei: '',
  };
  // Input para recibir el evento de redimensionamiento del mapa
  @Input() mapResizeEvent: boolean = false;

  currentSelectedImei: DropdownOption = {
    name: '',
    code: '',
  };
  histories: StoreHistory[] = [];
  historiesFiltered: StoreHistory[] = [];
  flagHistoriesFiltered = false;
  optionsImei: DropdownOption[] = [];
  private destroy$ = new Subject<void>();
  isShowAsideSection = true;
  displayDialog = false;
  displayDialogCustomHistory = false;
  customHistoryForm: FormGroup;
  @ViewChild('mapContainer') mapContainer!: ElementRef<HTMLElement>;
  searchHistory = new FormControl('');
  map!: L.Map;
  private historyGeofenceLayers: L.Layer[] = []; // Array para almacenar las capas creadas para el historial
  loadingCreateHistory$: Observable<boolean>;
  errorCreateHistory$: Observable<string | null>;
  currentHistory: StoreHistory | undefined;
  flagHiddenDialogCustomHistory = false;
  currentItemAside: AsideType = 'stops';
  itemsAside: MenuItem[] = [
    {
      label: 'Parada',
      icon: 'pi pi-pause',
      command: () => {
        this.managerHistoryAsideStops();
      },
    },
    {
      label: 'Tramas',
      icon: 'pi pi-circle-off',
      command: () => {
        this.managerHistoryAsideFrames();
      },
    },
    {
      label: 'Eventos',
      icon: 'pi pi-calendar',
      command: () => {
        this.managerHistoryAsideEvents();
      },
    },
  ];

  // Observable unificado que maneja todos los tipos de datos
  private historyDataSubject = new Subject<{
    stops: AsideHistoryCard<'stops'>[];
    frames: AsideHistoryCard<'frames'>[];
    events: AsideHistoryCard<'events'>[];
    imei: string;
  }>();
  private framesSubject = new Subject<FrameHistoryAdapted[]>();

  historyData$ = this.historyDataSubject.asObservable();
  framesData$ = this.framesSubject.asObservable();

  // Estado actual de las tarjetas seleccionadas
  private currentState = new Map<string, Map<string, boolean>>();
  // Polyline para el movimiento seleccionado
  // private polylineForMovement: L.Polyline | null = null;

  // CONFIGURACION DEL HISTORY DRAWER
  displayDialogSettings = false;
  displayDialogDashboard = false;
  showTechnicalParametersDialog = false;
  settings: SettingsHistoryDrawer = {
    showMovements: false,
    showStops: false,
    showStartRoute: false,
    showEndRoute: false,
    showFrames: false,
    showEvents: false,
    frameVariant: 'basic',
    routeWithDirection: true,
    animationDirection: true,
    routeWithSpeed: false,
    showGeofences: false,
    showCircularGeofences: false,
    showGeopoints: false,
  };
  lastSettings: SettingsHistoryDrawer = { ...this.settings };

  private geofences: DataGeofenceHistory[] | null = null;
  private geopoints: DataGeopointHistory[] | null = null;
  private circularGeofences: DataCircularGeofenceHistory[] | null = null;

  private controllerPolylineDecorators = new Map<
    string,
    ControllerPolylineDecorator
  >();
  private flagLoadState = false;
  private isZooming = false; // Bandera para evitar duplicar eventos
  private renderedFrameIds = new Set<number>(); // Almacena los IDs de los frames ya renderizados
  private maxFramesPerView = 30; // Límite máximo de frames por vista
  private lastZoom = 0; // Último nivel de zoom utilizado para detectar cambios
  private zoomFrameMap = new Map<number, Set<number>>(); // Almacena los frames renderizados por nivel de zoom

  constructor(
    private cdr: ChangeDetectorRef,
    private managerVehicleHistoryDrawerService: ManagerContentVehicleHistoryDrawerService,
    private leafletMapService: LeafletMapService,
    private fb: FormBuilder,
    private stateHistoryCardsService: StateHistoryCardsService,
    private container: ViewContainerRef,
    private geofencesService: GeofencesService,
    private geopointsService: GeopointsService,
    private circularGeofencesService: CircularGeofencesService,
    private stateSettingsHistoryDrawerService: StateSettingsHistoryDrawerService,
    public historialService: HistorialService
  ) {
    managerVehicleHistoryDrawerService.getHistories
      .pipe(
        takeUntil(this.destroy$),
        tap((histories) => {
          this.optionsImei = adapStoreHistoriesToDropdownOptions(histories);
          // historiales originales
          this.histories = histories;
          // historiales filtrados
          this.historiesFiltered = histories;
          // limpiar el input de búsqueda
          this.searchHistory.setValue('', { emitEvent: false });
        })
      )
      .subscribe();
    this.loadingCreateHistory$ =
      this.managerVehicleHistoryDrawerService.loadingCreateHistorySubject.pipe(
        switchMap((state: boolean) => {
          if (state) {
            return of(state);
          }
          return timer(500).pipe(mapTo(state));
        })
      );
    this.errorCreateHistory$ =
      this.managerVehicleHistoryDrawerService.errorCreateHistorySubject;

    console.log(
      this.historialService.config.form,
      'configuracion de historial'
    );
    this.customHistoryForm = this.fb.group(
      {
        start_date: this.fb.control(null, [Validators.required]),
        end_date: this.fb.control(null, [Validators.required]),
        time_start: this.fb.control(new Date('2018-03-12T00:00:00'), [
          Validators.required,
        ]),
        time_end: this.fb.control(new Date('2018-03-12T23:59:59'), [
          Validators.required,
        ]),
      },
      {
        validators: [
          startBeforeOrEqualEndValidator,
          notOlderThanNDaysValidator(90),
          maxRangeDaysValidator(15),
        ],
      }
    );

    // NO PUEDE SER DINAMICO PORQUE NO DETECTARIA SI UNA VARIANTE DEL FRAME SE MODIFICO Y NO LO LIMPIARIA
    // stateSettingsHistoryDrawerService.configHistoryDrawer$
    //   .pipe(
    //     takeUntil(this.destroy$),
    //     filter((config) => config !== null)
    //   )
    //   .subscribe((config) => {
    //     this.settings = config;
    //     this.lastSettings = config;
    //   });
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Detectar cuando cambie el evento de redimensionamiento del mapa
    if (changes['mapResizeEvent'] && changes['mapResizeEvent'].currentValue) {
      if (this.map) {
        this.leafletMapService.centerMapLeaflet(100, this.map);
      }
    }

    if (changes['dataHistoryDrawer']) {
      const currentUnit = this.getVehicleForImei(this.dataHistoryDrawer.imei);
      if (!currentUnit) {
        console.error(
          '(ContentVehicleHistoryDrawerComponent) No se encontró el vehículo en el store'
        );
        return;
      }
      // cerramos los dialogs
      this.hiddenDialogs();

      if (this.dataHistoryDrawer.variant === 'default') {
        this.managerDefaultHistory(currentUnit);
      } else {
        this.managerCustomHistory(currentUnit);
      }
    }
  }

  ngOnInit(): void {
    this.searchHistory.valueChanges
      .pipe(
        takeUntil(this.destroy$),
        filter((value) => value !== null),
        map((value) => value.trim().toLowerCase())
      )
      .subscribe((value) => {
        if (value.length === 0) {
          this.historiesFiltered = this.histories;
          return;
        }
        const units = this.histories.map((history) => history.unit);
        const unitsFiltered = this.applyFilterSearch(units, value);
        this.historiesFiltered = this.histories.filter((history) =>
          unitsFiltered.includes(history.unit)
        );
      });
  }

  ngAfterViewInit(): void {
    this.map = this.leafletMapService.newMapLeaflet(this.mapContainer);
    this.leafletMapService.centerMapLeaflet(400, this.map);

    // Inicializar el último zoom utilizado
    this.lastZoom = this.map.getZoom();

    const geofenceResponse =
      this.managerVehicleHistoryDrawerService.getGeofences();
    if (geofenceResponse.error === null) {
      this.geofences = geofenceResponse.data;
    }
    const geopointResponse =
      this.managerVehicleHistoryDrawerService.getGeopoints();
    if (geopointResponse.error === null) {
      this.geopoints = geopointResponse.data;
    }
    const circularGeofenceResponse =
      this.managerVehicleHistoryDrawerService.getCircularGeofences();
    if (circularGeofenceResponse.error === null) {
      this.circularGeofences = circularGeofenceResponse.data;
    }

    this.settings = {
      ...this.stateSettingsHistoryDrawerService.getCurrentConfig(),
    };
    this.lastSettings = { ...this.settings };

    this.managerVehicleHistoryDrawerService.getHistory
      .pipe(
        takeUntil(this.destroy$),
        filter((history): history is StoreHistory => history !== undefined),
        switchMap((history: StoreHistory) => {
          if (this.map) {
            this.flagLoadState = false;
            this.map.setZoom(8);
            this.leafletMapService.centerMapLeaflet(0, this.map);
          }
          return timer(300).pipe(mapTo(history));
        }),
        tap((newHistory) => {
          if (this.currentHistory) {
            this.removeHistoryForMap(this.currentHistory);
            this.stateHistoryCardsService.clearCardsByImei(
              this.currentHistory.unit.GNSSIMEI
            );
          }
          this.currentHistory = newHistory;
          console.log('(HISTORY) Nueva historia cargada', newHistory);
          this.flagLoadState = true;
          this.addHistoryForMap(newHistory);
          this.centerHistoryForMap(newHistory);

          // Emitir todos los datos unificados
          this.historyDataSubject.next({
            stops: this.adaptStops(newHistory),
            frames: this.adaptFrames(newHistory.detailsHistory.frames),
            events: this.adaptEvents(newHistory.detailsHistory.events),
            imei: newHistory.unit.GNSSIMEI,
          });
          this.framesSubject.next(newHistory.detailsHistory.frames);

          this.currentSelectedImei = {
            name: newHistory.unit.unitName,
            code: newHistory.unit.GNSSIMEI,
          };
        })
      )
      .subscribe();

    this.stateHistoryCardsService.state$
      .pipe(
        takeUntil(this.destroy$),
        tap((state) => {
          this.currentState = state;
          this.cdr.detectChanges();
        })
      )
      .subscribe();

    const geofences = this.geofencesService.getData();
    const geopoints = this.geopointsService.getData();
    const circularGeofences = this.circularGeofencesService.getData();
    console.log('(HISTORY) geofences', geofences);
    console.log('(HISTORY) geopoints', geopoints);
    console.log('(HISTORY) circularGeofences', circularGeofences);

    // Detectar inicio de zoom
    this.map.on('zoomstart', () => {
      this.isZooming = true;
    });

    // Detectar cuando finaliza el zoom
    this.map.on('zoomend', () => {
      if (!this.currentHistory || !this.flagLoadState) return;
      if (this.currentItemAside !== 'frames' && !this.settings.showFrames)
        return;

      const zoom = this.map.getZoom();
      const prevZoom = this.lastZoom;

      console.log('(HISTORY) Cambio de zoom:', prevZoom, '->', zoom);

      // Detectar si entramos o salimos del rango de zoom 9-10
      const isEnteringLowZoom =
        zoom >= 9 && zoom <= 10 && !(prevZoom >= 9 && prevZoom <= 10);
      const isLeavingLowZoom =
        !(zoom >= 9 && zoom <= 10) && prevZoom >= 9 && prevZoom <= 10;

      // Si entramos en la zona de zoom 9-10, renderizamos los frames estáticos
      if (isEnteringLowZoom) {
        console.log('(HISTORY) Entrando en zona de zoom estático (9-10)');
        // Limpiar todos los frames actuales
        this.removeVariantFrames(this.settings, this.currentHistory);
        this.renderedFrameIds.clear();
        this.zoomFrameMap.clear();

        // Renderizar los frames estáticos de una sola vez
        this.renderStaticLowZoomFrames(this.currentHistory, this.settings);
      }
      // Si salimos de la zona de zoom 9-10, limpiamos y aplicamos la lógica normal
      else if (isLeavingLowZoom) {
        console.log('(HISTORY) Saliendo de zona de zoom estático (9-10)');
        // Limpiar los frames estáticos
        this.removeVariantFrames(this.settings, this.currentHistory);
        this.renderedFrameIds.clear();
        this.zoomFrameMap.clear();

        // Procesar el cambio de zoom con la lógica normal
        this.managerZoomend(this.currentHistory, this.settings, zoom);
      }
      // Si estamos dentro del rango 9-10 y nos movemos dentro de él, no hacemos nada
      else if (zoom >= 9 && zoom <= 10) {
        console.log(
          '(HISTORY) Permaneciendo en zona de zoom estático (9-10), no se modifican frames'
        );
      }
      // En cualquier otro caso, aplicamos la lógica normal de zoom
      else if (zoom !== prevZoom) {
        // Eliminar frames dependiendo de si aumentamos o disminuimos el zoom
        if (zoom < prevZoom) {
          // Al reducir el zoom, eliminamos los frames que estaban en niveles de zoom más detallados
          console.log('(HISTORY) Reduciendo zoom, limpiando frames');
          this.clearFramesForZoomOut(
            this.currentHistory,
            this.settings,
            prevZoom,
            zoom
          );
        } else {
          // Al aumentar el zoom, mantenemos los frames existentes y añadiremos más
          console.log('(HISTORY) Aumentando zoom, manteniendo frames base');
        }

        // Actualizar el último zoom utilizado
        this.lastZoom = zoom;

        // Procesar el cambio de zoom
        this.managerZoomend(this.currentHistory, this.settings, zoom);
      }

      // Actualizamos el último zoom utilizado
      this.lastZoom = zoom;

      // Retrasamos el restablecimiento de la bandera para evitar eventos duplicados
      setTimeout(() => {
        this.isZooming = false;
      }, 100);
    });

    // Detectar cuando se desplaza el mapa sin cambiar el zoom
    this.map.on('moveend', () => {
      // No procesar si está en medio de un zoom o si no hay historia cargada
      if (!this.currentHistory || !this.flagLoadState || this.isZooming) return;

      const zoom = this.map.getZoom();

      // Para zoom 9-10, no hacer absolutamente nada durante el panning
      if (zoom >= 9 && zoom <= 10) {
        console.log(
          '(HISTORY) Movimiento en zoom estático (9-10), no se actualizan frames'
        );
        return;
      }

      // Solo actualizamos los frames si no estamos en zoom máximo (donde ya se muestran todos)
      // y si el zoom no ha cambiado (solo movimiento de paneo)
      if (zoom < 18 && zoom === this.lastZoom) {
        this.managerZoomend(this.currentHistory, this.settings, zoom);
      }
    });
  }

  private removeHistoryForMap(history: StoreHistory) {
    if (this.settings.routeWithSpeed) {
      // REMOVEMOS AQUELLA RUTA CON PINTADO DE VELOCIDADES
      history.speedSegments.forEach((segment) => {
        this.map.removeLayer(segment);
      });
    } else {
      // REMOVEMOS AQUELLA RUTA SIN PINTADO DE VELOCIDADES
      this.map.removeLayer(history.polyline);
    }
    this.removeInMapMarkersForStops(history);
    this.removeInMapMarkersForFrames(history);
    this.removeInMapMarkersForEvents(history);
    // Remover flechas direccionales
    history.directionArrows.forEach((arrow) => {
      arrow.remove();
    });
    history.speedDirectionArrows.forEach((arrow) => {
      arrow.remove();
    });
    history.polylineDecorator.remove();

    // Destruir animación completamente si existe
    const imei = history.unit.GNSSIMEI;
    const framesCount = history.detailsHistory.frames.length;
    const historyKey = `${imei}_${history.detailsHistory.start_date}_${history.detailsHistory.end_date}_${framesCount}`;
    const controller = this.controllerPolylineDecorators.get(historyKey);
    if (controller) {
      controller.destroy();
      this.controllerPolylineDecorators.delete(historyKey);
    }
  }

  private addHistoryForMap(history: StoreHistory) {
    const variantAside = this.currentItemAside;
    const imei = history.unit.GNSSIMEI;
    const framesCount = history.detailsHistory.frames.length;
    const historyKey = `${imei}_${history.detailsHistory.start_date}_${history.detailsHistory.end_date}_${framesCount}`;

    // Destruir cualquier animación anterior para este IMEI antes de crear una nueva
    this.controllerPolylineDecorators.forEach((controller, key) => {
      if (key.startsWith(imei + '_')) {
        controller.destroy();
        this.controllerPolylineDecorators.delete(key);
      }
    });

    // Crear nuevo controller polyline para esta ruta específica
    const controller = animatePolylineDecorator(
      history.polylineDecorator,
      this.map,
      DEFAULT_OPTIONS.patterns,
      {
        speed: 0.3,
        maxZoom: 16,
        fps: 24,
      }
    );
    this.controllerPolylineDecorators.set(historyKey, controller);

    if (this.settings.animationDirection) {
      controller.resume();
    } else {
      controller.pause();
    }

    if (this.settings.routeWithSpeed) {
      // AGREGAMOS AQUELLA RUTA CON PINTADO DE VELOCIDADES
      history.speedSegments.forEach((segment) => {
        this.map.addLayer(segment);
      });
      // if (this.settings.routeWithDirection) {
      //   history.speedDirectionArrows.forEach((direction) => {
      //     this.map.addLayer(direction);
      //   });
      // }
    } else {
      // AGREGAMOS AQUELLA RUTA SIN PINTADO DE VELOCIDADES
      this.map.addLayer(history.polyline);
      // if (this.settings.routeWithDirection) {
      //   history.directionArrows.forEach((direction) => {
      //     this.map.addLayer(direction);
      //   });
      // }
    }

    // AGREGAMOS AQUELLA RUTA CON PINTADO DE DIRECCIONES
    if (this.settings.routeWithDirection) {
      this.map.addLayer(history.polylineDecorator);
    }

    this.removeVariantGeofences();
    if (this.settings.showGeofences) {
      this.addVariantGeofences();
    }

    this.removeVariantCircularGeofences();
    if (this.settings.showCircularGeofences) {
      this.addVariantCircularGeofences();
    }

    this.removeVariantGeopoints();
    if (this.settings.showGeopoints) {
      this.addVariantGeopoints();
    }

    switch (variantAside) {
      case 'stops':
        this.addInMapMarkersForStops(history);
        break;
      case 'frames':
        this.addInMapMarkersForFrames(history);
        break;
      case 'events':
        this.addInMapMarkersForEvents(history);
        break;
    }
  }

  refreshHistory(history: StoreHistory) {
    this.managerDefaultHistory(history.unit);
  }

  centerHistoryForMap(history: StoreHistory) {
    this.leafletMapService.centerPolylineLeaflet(
      history.polyline,
      this.map,
      800
    );
  }

  private adaptStops(history: StoreHistory): AsideHistoryCard<'stops'>[] {
    const stops = history.detailsHistory.stops;
    const adaptedStops = stops.map((stop, index) => {
      const date = formatDateOnly(stop.start);
      const time = formatTimeOnly(stop.start);
      return {
        id: index + 1,
        type: 'stops' as const,
        variant: 'stop' as const,
        date,
        time,
        numeration: `${index + 1}`,
        duration: convertSecondsToTimeString(stop.duration_s, {
          shortFormat: true,
          showZeros: false,
        }),
      };
    });

    // Inicializar las tarjetas en el servicio de estado
    this.stateHistoryCardsService.addMultipleCards(
      history.unit.GNSSIMEI,
      adaptedStops.map((stop) => ({
        id: stop.id,
        type: stop.type,
        variant: stop.variant,
      }))
    );

    const adaptedMovements = history.detailsHistory.movements.map(
      (movement, index) => {
        const date = formatDateOnly(movement.start);
        const time = formatTimeOnly(movement.start);
        return {
          id: index + 1,
          type: 'stops' as const,
          variant: 'movement' as const,
          date,
          time,
          numeration: `${index + 1}`,
          duration: convertSecondsToTimeString(movement.duration_s, {
            shortFormat: true,
            showZeros: false,
          }),
        };
      }
    );

    this.stateHistoryCardsService.addMultipleCards(
      history.unit.GNSSIMEI,
      adaptedMovements.map((movement) => ({
        id: movement.id,
        type: movement.type,
        variant: movement.variant,
      }))
    );

    const startFrame = history.detailsHistory.startFrame;
    const endFrame = history.detailsHistory.endFrame;
    const adaptedStartFrame: AsideHistoryCard<'stops'> = {
      id: idStartFrame,
      type: 'stops' as const,
      variant: 'start' as const,
      date: formatDateTrackerDate(startFrame.date),
      time: formatDateTrackerTime(startFrame.date),
      numeration: '',
      duration: '0',
    };
    const adaptedEndFrame: AsideHistoryCard<'stops'> = {
      id: idEndFrame,
      type: 'stops' as const,
      variant: 'end' as const,
      date: formatDateTrackerDate(endFrame.date),
      time: formatDateTrackerTime(endFrame.date),
      numeration: '',
      duration: '0',
    };

    this.stateHistoryCardsService.addCard(
      history.unit.GNSSIMEI,
      adaptedStartFrame.id,
      adaptedStartFrame.type,
      adaptedStartFrame.variant
    );

    this.stateHistoryCardsService.addCard(
      history.unit.GNSSIMEI,
      adaptedEndFrame.id,
      adaptedEndFrame.type,
      adaptedEndFrame.variant
    );

    const allElements = [
      adaptedStartFrame,
      ...adaptedStops,
      ...adaptedMovements,
      adaptedEndFrame,
    ];

    const sortedElements = allElements.sort((a, b) => {
      if (a.date !== b.date) {
        return a.date.localeCompare(b.date);
      }
      if (a.time !== b.time) {
        return a.time.localeCompare(b.time);
      }
      if (a.variant === 'stop' && b.variant === 'movement') {
        return -1;
      }
      if (a.variant === 'movement' && b.variant === 'stop') {
        return 1;
      }
      if (a.variant === 'start') return -1;
      if (a.variant === 'end') return 1;
      if (b.variant === 'start') return 1;
      if (b.variant === 'end') return -1;
      return 0;
    });

    return sortedElements;
  }

  private adaptFrames(
    frames: FrameHistoryAdapted[]
  ): AsideHistoryCard<'frames'>[] {
    const framesAdapted = frames.map((frame, index) => {
      return {
        id: index + 1,
        type: 'frames' as const,
        variant: frame.variant,
        date: formatDateTrackerDate(frame.date),
        time: formatDateTrackerTime(frame.date),
        numeration: `${index + 1}`,
        duration: `${frame.speed} km/h`,
      };
    });

    // Inicializar las tarjetas en el servicio de estado
    this.stateHistoryCardsService.addMultipleCards(
      this.currentHistory?.unit.GNSSIMEI ?? '',
      framesAdapted.map((frame) => ({
        id: frame.id,
        type: frame.type,
        variant: frame.variant,
      }))
    );

    return framesAdapted;
  }

  private adaptEvents(events: EventData[]): AsideHistoryCard<'events'>[] {
    const eventsAdapted = events.map((event, index) => {
      return {
        id: index + 1,
        type: 'events' as const,
        variant: 'event' as const,
        date: formatDateTrackerDate(event.fecha_tracker),
        time: formatDateTrackerTime(event.fecha_tracker),
        numeration: `${index + 1}`,
        duration: '0',
        contentMessage:
          event.name ?? event.nombre ?? event.mensaje_alerta ?? 'Desconocido',
      };
    });

    this.stateHistoryCardsService.addMultipleCards(
      this.currentHistory?.unit.GNSSIMEI ?? '',
      eventsAdapted.map((event) => ({
        id: event.id,
        type: event.type,
        variant: event.variant,
      }))
    );

    return eventsAdapted;
  }

  private managerDefaultHistory(unit: Unit) {
    // BAD CODING, TODO: REFACTOR THIS, ESPEREMOS LA IMPLEMENTACIÓN del managerCustomHistory
    const now = new Date();
    const pad = (n: number) => `${n}`.padStart(2, '0');
    const yyyy = now.getFullYear();
    const mm = pad(now.getMonth() + 1);
    const dd = pad(now.getDate());
    const hh = pad(now.getHours());
    const mi = pad(now.getMinutes());
    const ss = pad(now.getSeconds());
    const today = `${yyyy}-${mm}-${dd}`;
    const startTime = '00:00:00';
    const endTime = `${hh}:${mi}:${ss}`;

    this.managerVehicleHistoryDrawerService.createHistory(
      {
        start_date: today,
        end_date: today,
        time_start: startTime,
        time_end: endTime,
        unit: unit,
      },
      this.container
    );
  }

  private managerCustomHistory(unit: Unit) {
    this.flagHiddenDialogCustomHistory = false;
    this.showDialogCustomHistory();
  }

  private getVehicleForImei(imei: string): Unit | undefined {
    return this.managerVehicleHistoryDrawerService.getDetailVehicle(imei);
  }

  onImeiSelect() {
    const imei = this.currentSelectedImei.code || '';
    this.managerVehicleHistoryDrawerService.setCurrentImei = imei;
  }

  toggleShowAsideSection() {
    this.isShowAsideSection = !this.isShowAsideSection;
    this.leafletMapService.centerMapLeaflet(100, this.map);
  }

  showDialog() {
    this.displayDialog = true;
  }

  showDialogCustomHistory() {
    this.displayDialogCustomHistory = true;
  }

  hideDialogCustomHistory() {
    this.displayDialogCustomHistory = false;
  }

  setDefaultCustomHistoryDates() {
    const pad = (n: number) => `${n}`.padStart(2, '0');
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);

    const formatDate = (d: Date) =>
      `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

    // --- Obtiene configuración previa si existe ---
    const cfg = this.historialService.config.form;

    // --- Fecha y hora inicial ---
    const startDate = cfg.startDate || formatDate(today);
    const startTime =
      cfg.startTime instanceof Date
        ? cfg.startTime
        : new Date(`${startDate}T00:00:00`);

    // --- Fecha y hora final ---
    const endDate = cfg.endDate || formatDate(tomorrow);
    const endTime =
      cfg.endTime instanceof Date
        ? cfg.endTime
        : new Date(`${endDate}T00:00:00`);

    // --- Asignar al formulario ---
    this.customHistoryForm.patchValue({
      start_date: startDate,
      time_start: startTime,
      end_date: endDate,
      time_end: endTime,
    });

    // Fuerza la revalidación de todo el formulario
    this.customHistoryForm.updateValueAndValidity({
      onlySelf: false,
      emitEvent: true,
    });

    // Opcional: marcar como limpio (si no quieres mostrar errores aún)
    this.customHistoryForm.markAsPristine();
  }

  handleHiddenDialogCustomHistory(flag: boolean = false) {
    console.log('(HISTORY) hidden dialog custom history', flag);
    if (flag) {
      this.hideDialogCustomHistory();
      return;
    }
    this.customHistoryForm.reset();
    if (this.optionsImei.length === 0) {
      this.managerVehicleHistoryDrawerService.deleteAllHistories();
      return;
    }
    this.hideDialogCustomHistory();
  }

  handleCreateCustomHistory() {
    const formValue = this.customHistoryForm.value;
    const unit = this.getVehicleForImei(this.dataHistoryDrawer.imei);
    if (!unit) {
      console.error(
        '(ContentVehicleHistoryDrawerComponent) No se encontró el vehículo en el store'
      );
      this.handleHiddenDialogCustomHistory();
      return;
    }

    // Convertir Date objects a formato HH:mm:ss string
    const timeStart = formValue.time_start
      ? this.formatTimeToString(formValue.time_start)
      : '00:00:00';
    const timeEnd = formValue.time_end
      ? this.formatTimeToString(formValue.time_end)
      : '23:59:59';

    console.log('(HISTORY) formValue', formValue);
    this.managerVehicleHistoryDrawerService.createHistory(
      {
        start_date: formValue.start_date,
        end_date: formValue.end_date,
        time_start: timeStart,
        time_end: timeEnd,
        unit: unit,
      },
      this.container
    );
    this.flagHiddenDialogCustomHistory = true;
    this.handleHiddenDialogCustomHistory(true);
  }

  handleShowHistory(imei: string) {
    const currentUnit = this.getVehicleForImei(imei);
    if (!currentUnit) {
      console.error(
        '(ContentVehicleHistoryDrawerComponent) No se encontró el vehículo en el store'
      );
      return;
    }
    this.displayDialog = false;
    this.managerVehicleHistoryDrawerService.setCurrentImei =
      currentUnit.GNSSIMEI;
  }

  handleDeleteHistory(imei: string) {
    const optionsImei = this.optionsImei;
    const currentImei = this.currentSelectedImei.code;
    if (optionsImei.length > 1 && imei === currentImei) {
      this.managerChangeCurrentImei(optionsImei, imei);
    }

    // Limpiar el estado de las tarjetas del IMEI eliminado
    this.stateHistoryCardsService.clearCardsByImei(imei);

    this.managerVehicleHistoryDrawerService.deleteHistory(imei);
  }

  private managerChangeCurrentImei(
    optionsImei: DropdownOption[],
    imei: string
  ) {
    const filterCurrentImei = optionsImei.filter(
      (option) => option.code !== imei
    );
    this.managerVehicleHistoryDrawerService.setCurrentImei =
      filterCurrentImei[0].code;
  }

  adaptHistoryCard(data: StoreHistory): HistoryCard {
    return adaptHistoryCard(data);
  }

  clearErrorHistory() {
    this.managerVehicleHistoryDrawerService.clearErrorCreateHistory();
    if (this.optionsImei.length === 0) {
      this.managerVehicleHistoryDrawerService.deleteAllHistories();
      // Limpiar todos los estados de las tarjetas
      this.stateHistoryCardsService.clearAllCards();
      return;
    }
  }

  retryCreateHistory() {
    const currentImei = this.dataHistoryDrawer.imei;
    const unit = this.getVehicleForImei(currentImei);
    if (!unit) {
      console.error(
        '(ContentVehicleHistoryDrawerComponent) No se encontró el vehículo en el store'
      );
      return;
    }
    this.dataHistoryDrawer = {
      variant: 'custom',
      imei: currentImei,
    };
    this.managerCustomHistory(unit);
    this.managerVehicleHistoryDrawerService.clearErrorCreateHistory();
  }

  getNameUnit(imei: string) {
    const unit = this.getVehicleForImei(imei);
    return unit?.unitName;
  }

  getTitleAside(type: AsideType) {
    switch (type) {
      case 'stops':
        return 'Paradas en ruta';
      case 'frames':
        return 'Tramas de ruta';
      case 'events':
        return 'Eventos en ruta';
      default:
        return 'Ocurrió un error';
    }
  }

  isCardSelected(id: number, type: string, variant: string = 'stop'): boolean {
    const currentImei = this.currentHistory?.unit.GNSSIMEI ?? '';
    if (!currentImei) return false;

    const imeiMap = this.currentState.get(currentImei);
    if (!imeiMap) return false;

    const key = `${id}-${type}-${variant}`;
    return imeiMap.get(key) ?? false;
  }

  handleSelectCard(event: {
    id: number;
    type: string;
    variant: string;
    isSelected: boolean;
  }) {
    // Auxiliar para deseleccionar el movimiento si se seleccicona otra tarjeta
    // if (this.polylineForMovement) {
    //   this.polylineForMovement.remove();
    //   this.polylineForMovement = null;
    // }

    if (event.type === 'stops' && this.currentHistory) {
      switch (event.variant) {
        case 'start':
          this.handleStartCardSelection();
          break;
        case 'end':
          this.handleEndCardSelection();
          break;
        case 'stop':
          this.handleStopCardSelection(event.id);
          break;
        case 'movement':
          this.handleMovementCardSelection(event.id);
          break;
      }
    } else if (event.type === 'frames' && this.currentHistory) {
      this.handleFrameCardSelection(event.id);
      // switch (event.variant) {
      //   case 'frame':

      //     break;
      // }
    } else if (event.type === 'events' && this.currentHistory) {
      switch (event.variant) {
        case 'event':
          this.handleEventCardSelection(event.id);
          break;
      }
    }
  }

  handleRedirectTo(type: AsideType) {
    switch (type) {
      case 'stops':
        this.managerHistoryAsideStops();
        break;
      case 'frames':
        this.managerHistoryAsideFrames();
        break;
      case 'events':
        this.managerHistoryAsideEvents();
        break;
    }
  }

  private handleStopCardSelection(stopId: number) {
    if (!this.currentHistory || !this.map) return;

    const markerIndex = stopId - 1;

    if (
      markerIndex >= 0 &&
      markerIndex < this.currentHistory.stopMarkers.length
    ) {
      const selectedMarker = this.currentHistory.stopMarkers[markerIndex];
      if (selectedMarker.isPopupOpen()) {
        selectedMarker.closePopup();
      } else {
        selectedMarker.openPopup();
        this.leafletMapService.centerMarkerLeaflet(
          selectedMarker,
          this.map,
          100
        );
      }
    }
  }

  private handleMovementCardSelection(movementId: number) {
    if (!this.currentHistory || !this.map) return;
    const polylineIndex = movementId - 1;
    if (
      polylineIndex >= 0 &&
      polylineIndex < this.currentHistory.movementsPolylines.length
    ) {
      const selectedPolyline =
        this.currentHistory.movementsPolylines[polylineIndex];

      if (selectedPolyline.isPopupOpen()) {
        selectedPolyline.closePopup();
      } else {
        selectedPolyline.openPopup();
        this.leafletMapService.centerPolylineLeaflet(
          selectedPolyline,
          this.map,
          100
        );
      }

      // const currentState = this.stateHistoryCardsService.isCardSelected(
      //   this.currentHistory.unit.GNSSIMEI,
      //   movementId,
      //   'stops',
      //   'movement'
      // );

      // Desactivar todos los popups abiertos de los markers
      // if (this.map) {
      //   this.map.closePopup();
      // }

      // if (currentState) {
      //   this.stateHistoryCardsService.deselectCard(
      //     this.currentHistory.unit.GNSSIMEI,
      //     movementId,
      //     'stops',
      //     'movement'
      //   );
      //   return;
      // }

      // this.polylineForMovement = selectedPolyline;
      // this.map.addLayer(selectedPolyline);
      // this.leafletMapService.centerPolylineLeaflet(
      //   selectedPolyline,
      //   this.map,
      //   100
      // );
      // this.stateHistoryCardsService.selectCard(
      //   this.currentHistory.unit.GNSSIMEI,
      //   movementId,
      //   'stops',
      //   'movement'
      // );
    }
  }

  private handleFrameCardSelection(frameId: number) {
    const variant = this.settings.frameVariant;
    let marker: L.Marker | L.CircleMarker | undefined;

    switch (variant) {
      case 'basic':
        // Para 'basic' usamos circleMarkers que ya existen
        marker = this.currentHistory?.circleMarkers[frameId - 1];
        break;
      case 'speed':
        marker = this.currentHistory?.variantsFrameMarkers?.speed[frameId - 1];
        break;
      case 'time':
        marker = this.currentHistory?.variantsFrameMarkers?.time[frameId - 1];
        break;
      case 'speed-time':
        marker =
          this.currentHistory?.variantsFrameMarkers?.speedTime[frameId - 1];
        break;
      default:
        // Por defecto usar basic
        marker = this.currentHistory?.circleMarkers[frameId - 1];
        break;
    }

    if (!marker) return;
    if (marker.isPopupOpen()) {
      marker.closePopup();
    } else {
      marker.openPopup();
      if (marker instanceof L.CircleMarker) {
        this.leafletMapService.centerCircleMarkerLeaflet(marker, this.map, 100);
      } else {
        this.leafletMapService.centerMarkerLeaflet(marker, this.map, 100, 18);
      }
    }
  }

  private handleEventCardSelection(eventId: number) {
    const event = this.currentHistory?.eventsMarkers[eventId - 1];
    if (!event) return;
    if (event.isPopupOpen()) {
      event.closePopup();
    } else {
      event.openPopup();
      this.leafletMapService.centerMarkerLeaflet(event, this.map, 100);
    }
  }

  private handleStartCardSelection() {
    const marker = this.currentHistory?.startMarker;
    if (!marker) return;
    if (marker.isPopupOpen()) {
      marker.closePopup();
    } else {
      marker.openPopup();
      this.leafletMapService.centerMarkerLeaflet(marker, this.map, 100);
    }
  }

  private handleEndCardSelection() {
    const marker = this.currentHistory?.endMarker;
    if (!marker) return;
    if (marker.isPopupOpen()) {
      marker.closePopup();
    } else {
      marker.openPopup();
      this.leafletMapService.centerMarkerLeaflet(marker, this.map, 100);
    }
  }

  private managerHistoryAsideStops() {
    const lastCurrentItemAside = this.currentItemAside;

    if (lastCurrentItemAside === 'stops') return;
    this.currentItemAside = 'stops';

    switch (lastCurrentItemAside) {
      case 'frames':
        this.removeInMapMarkersForFrames(this.currentHistory);
        break;
      case 'events':
        this.removeInMapMarkersForEvents(this.currentHistory);
        break;
    }

    this.addInMapMarkersForStops(this.currentHistory);
  }

  private managerHistoryAsideFrames() {
    const lastCurrentItemAside = this.currentItemAside;
    if (lastCurrentItemAside === 'frames') return;
    this.currentItemAside = 'frames';

    switch (lastCurrentItemAside) {
      case 'stops':
        this.removeInMapMarkersForStops(this.currentHistory);
        break;
      case 'events':
        this.removeInMapMarkersForEvents(this.currentHistory);
        break;
    }

    this.addInMapMarkersForFrames(this.currentHistory);
  }

  private managerHistoryAsideEvents() {
    const lastCurrentItemAside = this.currentItemAside;
    if (lastCurrentItemAside === 'events') return;
    this.currentItemAside = 'events';

    switch (lastCurrentItemAside) {
      case 'stops':
        this.removeInMapMarkersForStops(this.currentHistory);
        break;
      case 'frames':
        this.removeInMapMarkersForFrames(this.currentHistory);
        break;
    }

    this.addInMapMarkersForEvents(this.currentHistory);
  }

  private addInMapMarkersForStops(history: StoreHistory | undefined) {
    if (!history) return;
    history?.stopMarkers.forEach((stopMarker) => {
      this.map.addLayer(stopMarker);
    });
    history.movementsPolylines.forEach((polyline) => {
      this.map.addLayer(polyline);
    });
    this.map.addLayer(history.startMarker);
    this.map.addLayer(history.endMarker);

    // CONFIGURACION PERSONALIZADA DEL USUARIO
    this.managerSettingsStops(this.settings, history);
  }

  private removeInMapMarkersForStops(history: StoreHistory | undefined) {
    if (!history) return;
    history?.stopMarkers.forEach((stopMarker) => {
      stopMarker.remove();
    });
    history.movementsPolylines.forEach((polyline) => {
      polyline.remove();
    });
    history.startMarker.remove();
    history.endMarker.remove();

    // CONFIGURACION PERSONALIZADA DEL USUARIO
    this.removeMarkersSettingsForStops(history);
  }

  private addInMapMarkersForFrames(history: StoreHistory | undefined) {
    if (!history) return;
    // this.addVariantFrames(this.settings, history);
    this.managerZoomend(history, this.settings, this.map.getZoom());

    // CONFIGURACION PERSONALIZADA DEL USUARIO
    this.managerSettingsFrames(this.settings, history);
  }

  private removeInMapMarkersForFrames(history: StoreHistory | undefined) {
    if (!history) return;
    this.removeVariantFrames(this.settings, history);

    // CONFIGURACION PERSONALIZADA DEL USUARIO
    this.removeMarkersSettingsForFrames(history);
  }

  private addInMapMarkersForEvents(history: StoreHistory | undefined) {
    if (!history) return;
    history?.eventsMarkers.forEach((eventMarker) => {
      this.map.addLayer(eventMarker);
    });

    // CONFIGURACION PERSONALIZADA DEL USUARIO
    this.managerSettingsEvents(this.settings, history);
  }

  private removeInMapMarkersForEvents(history: StoreHistory | undefined) {
    if (!history) return;
    history?.eventsMarkers.forEach((eventMarker) => {
      eventMarker.remove();
    });

    // CONFIGURACION PERSONALIZADA DEL USUARIO
    this.removeMarkersSettingsForEvents(history);
  }

  formatMessageToastHistory(details: DetailsHistory | undefined) {
    return formatMessageToastHistory(details);
  }

  trackByHistory(_index: number, history: StoreHistory) {
    return history.unit.GNSSIMEI;
  }

  private applyFilterSearch(units: Unit[], input: string): Unit[] {
    return units.filter((unit) => {
      const imei = unit.device?.IMEI?.toString().toLowerCase() || '';
      const licensePlate = unit.licensePlate?.toString().toLowerCase() || '';
      const code = unit.internalCode?.toString().toLowerCase() || '';
      const unitName = unit.unitName?.toString().toLowerCase() || '';
      return (
        imei.startsWith(input) ||
        licensePlate.startsWith(input) ||
        code.includes(input) ||
        unitName.startsWith(input)
      );
    });
  }

  // CONFIGURACION DEL HISTORY DRAWER
  showSettingsDialog() {
    this.displayDialogSettings = true;
  }

  showDashboard() {
    this.displayDialogDashboard = true;
  }

  hideDashboard() {
    this.displayDialogDashboard = false;
  }

  showTechnicalParameters() {
    this.showTechnicalParametersDialog = true;
    this.cdr.detectChanges();
  }

  hideTechnicalParameters() {
    this.showTechnicalParametersDialog = false;
    this.cdr.detectChanges();
  }

  hideSettingsDialog() {
    this.displayDialogSettings = false;
  }

  saveSettings() {
    const currentSettings = { ...this.settings };
    const currentHistory = this.currentHistory;
    if (!currentHistory) return;
    if (this.currentItemAside === 'stops') {
      this.managerSettingsStops(currentSettings, currentHistory);
    }
    if (this.currentItemAside === 'frames') {
      this.managerSettingsFrames(currentSettings, currentHistory);
    }
    if (this.currentItemAside === 'events') {
      this.managerSettingsEvents(currentSettings, currentHistory);
    }

    if (currentSettings.routeWithSpeed !== this.lastSettings.routeWithSpeed) {
      if (currentSettings.routeWithSpeed) {
        // AGREGAR AQUELLA RUTA CON PINTADO DE VELOCIDADES
        currentHistory.polyline.remove();
        currentHistory.speedSegments.forEach((segment) => {
          this.map.addLayer(segment);
        });
      } else {
        // REMOVER AQUELLA RUTA CON PINTADO DE VELOCIDADES
        currentHistory.speedSegments.forEach((segment) => {
          this.map.removeLayer(segment);
        });
        this.map.addLayer(currentHistory.polyline);
      }

      if (this.currentItemAside === 'stops' || currentSettings.showMovements) {
        currentHistory.movementsPolylines.forEach((polyline) => {
          this.map.removeLayer(polyline);
        });
        currentHistory.movementsPolylines.forEach((polyline) => {
          this.map.addLayer(polyline);
        });
      }
    }

    // Manejar flechas direccionales
    if (currentSettings.routeWithDirection) {
      this.map.addLayer(currentHistory.polylineDecorator);
    } else {
      this.map.removeLayer(currentHistory.polylineDecorator);
    }

    if (currentSettings.animationDirection) {
      this.controllerPolylineDecorators.forEach((controller) =>
        controller.resume()
      );
    } else {
      this.controllerPolylineDecorators.forEach((controller) =>
        controller.pause()
      );
    }

    if (currentSettings.showGeofences) {
      this.addVariantGeofences();
    } else {
      this.removeVariantGeofences();
    }

    if (currentSettings.showCircularGeofences) {
      this.addVariantCircularGeofences();
    } else {
      this.removeVariantCircularGeofences();
    }

    if (currentSettings.showGeopoints) {
      this.addVariantGeopoints();
    } else {
      this.removeVariantGeopoints();
    }

    this.lastSettings = currentSettings;
    this.displayDialogSettings = false;
  }

  private managerSettingsStops(
    settings: SettingsHistoryDrawer,
    history: StoreHistory
  ) {
    // if (settings.showFrames) {
    //   this.addVariantFrames(settings, history);
    // } else {
    //   this.removeVariantFrames(settings, history);
    // }

    if (settings.showEvents) {
      history.eventsMarkers.forEach((marker) => {
        this.map.addLayer(marker);
      });
    } else {
      history.eventsMarkers.forEach((marker) => {
        marker.remove();
      });
    }

    // if (
    //   this.lastSettings.frameVariant !== settings.frameVariant &&
    //   settings.showFrames
    // ) {
    //   this.removeVariantFrames(this.lastSettings, history);
    //   // this.addVariantFrames(settings, history);
    //   this.managerZoomend(history, settings, this.map.getZoom());
    // }
    this.removeVariantFrames(this.lastSettings, history);
    this.managerZoomend(history, settings, this.map.getZoom());
  }
  private managerSettingsFrames(
    settings: SettingsHistoryDrawer,
    history: StoreHistory
  ) {
    if (settings.showStops) {
      history.stopMarkers.forEach((marker) => {
        this.map.addLayer(marker);
      });
    } else {
      history.stopMarkers.forEach((marker) => {
        marker.remove();
      });
    }

    if (settings.showEvents) {
      history.eventsMarkers.forEach((marker) => {
        this.map.addLayer(marker);
      });
    } else {
      history.eventsMarkers.forEach((marker) => {
        marker.remove();
      });
    }

    if (settings.showMovements) {
      history.movementsPolylines.forEach((polyline) => {
        this.map.addLayer(polyline);
      });
    } else {
      history.movementsPolylines.forEach((polyline) => {
        polyline.remove();
      });
    }

    if (settings.showStartRoute) {
      this.map.addLayer(history.startMarker);
    } else {
      history.startMarker.remove();
    }

    if (settings.showEndRoute) {
      this.map.addLayer(history.endMarker);
    } else {
      history.endMarker.remove();
    }

    // if (this.lastSettings.frameVariant !== settings.frameVariant) {
    //   this.removeVariantFrames(this.lastSettings, history);
    //   // this.addVariantFrames(settings, history);
    //   this.managerZoomend(history, settings, this.map.getZoom());
    // }
    this.removeVariantFrames(this.lastSettings, history);
    this.managerZoomend(history, settings, this.map.getZoom());
  }
  private managerSettingsEvents(
    settings: SettingsHistoryDrawer,
    history: StoreHistory
  ) {
    if (settings.showStops) {
      history.stopMarkers.forEach((marker) => {
        this.map.addLayer(marker);
      });
    } else {
      history.stopMarkers.forEach((marker) => {
        marker.remove();
      });
    }

    if (settings.showMovements) {
      history.movementsPolylines.forEach((polyline) => {
        this.map.addLayer(polyline);
      });
    } else {
      history.movementsPolylines.forEach((polyline) => {
        polyline.remove();
      });
    }

    // if (settings.showFrames) {
    //   this.addVariantFrames(settings, history);
    // } else {
    //   this.removeVariantFrames(settings, history);
    // }

    if (settings.showStartRoute) {
      this.map.addLayer(history.startMarker);
    } else {
      history.startMarker.remove();
    }

    if (settings.showEndRoute) {
      this.map.addLayer(history.endMarker);
    } else {
      history.endMarker.remove();
    }

    // if (
    //   this.lastSettings.frameVariant !== settings.frameVariant &&
    //   settings.showFrames
    // ) {
    //   this.removeVariantFrames(this.lastSettings, history);
    //   this.managerZoomend(history, settings, this.map.getZoom());
    // }

    this.removeVariantFrames(this.lastSettings, history);
    this.managerZoomend(history, settings, this.map.getZoom());
  }

  private removeMarkersSettingsForStops(history: StoreHistory) {
    history.circleMarkers.forEach((marker) => {
      this.map.removeLayer(marker);
    });
    history.eventsMarkers.forEach((marker) => {
      this.map.removeLayer(marker);
    });
  }
  private removeMarkersSettingsForFrames(history: StoreHistory) {
    history.stopMarkers.forEach((marker) => {
      this.map.removeLayer(marker);
    });
    history.movementsPolylines.forEach((polyline) => {
      this.map.removeLayer(polyline);
    });
    history.eventsMarkers.forEach((marker) => {
      this.map.removeLayer(marker);
    });
    history.startMarker.remove();
    history.endMarker.remove();
  }
  private removeMarkersSettingsForEvents(history: StoreHistory) {
    history.stopMarkers.forEach((marker) => {
      this.map.removeLayer(marker);
    });
    history.movementsPolylines.forEach((polyline) => {
      this.map.removeLayer(polyline);
    });
    history.circleMarkers.forEach((marker) => {
      this.map.removeLayer(marker);
    });
    history.startMarker.remove();
    history.endMarker.remove();
  }

  private addVariantFrames(
    settings: SettingsHistoryDrawer,
    history: StoreHistory
  ) {
    // POR EL MOMENTO ES LA MEJOR SOLUCION SIEMPRE QUE INVOQUEN ESTA FUNCION ELIMINAR LOS FRAMES
    this.removeVariantFrames(settings, history);

    // Actualizar el último zoom usado
    this.lastZoom = this.map.getZoom();

    const variant = settings.frameVariant;
    switch (variant) {
      case 'basic':
        history.circleMarkers.forEach((circle) => {
          this.map.addLayer(circle);
        });
        break;
      case 'speed':
        history.variantsFrameMarkers?.speed.forEach((marker) => {
          this.map.addLayer(marker);
        });
        break;
      case 'time':
        history.variantsFrameMarkers?.time.forEach((marker) => {
          this.map.addLayer(marker);
        });
        break;
      case 'speed-time':
        history.variantsFrameMarkers?.speedTime.forEach((marker) => {
          this.map.addLayer(marker);
        });
        break;
    }
  }

  private removeVariantFrames(
    settings: SettingsHistoryDrawer,
    history: StoreHistory
  ) {
    const variant = settings.frameVariant;
    switch (variant) {
      case 'basic':
        history.circleMarkers.forEach((circle) => {
          this.map.removeLayer(circle);
        });
        break;
      case 'speed':
        history.variantsFrameMarkers?.speed.forEach((marker) => {
          this.map.removeLayer(marker);
        });
        break;
      case 'time':
        history.variantsFrameMarkers?.time.forEach((marker) => {
          this.map.removeLayer(marker);
        });
        break;
      case 'speed-time':
        history.variantsFrameMarkers?.speedTime.forEach((marker) => {
          this.map.removeLayer(marker);
        });
        break;
    }

    // Al eliminar los frames, limpiamos también la caché de frames renderizados
    this.renderedFrameIds.clear();
  }

  private addVariantGeofences() {
    if (this.geofences === null) return;

    this.geofences.forEach(({ polygon, marker }) => {
      this.map.addLayer(polygon);
      if (marker !== null) {
        this.map.addLayer(marker);
      }
    });
  }
  private removeVariantGeofences() {
    if (this.geofences === null) return;

    this.geofences.forEach(({ polygon, marker }) => {
      this.map.removeLayer(polygon);
      if (marker !== null) {
        this.map.removeLayer(marker);
      }
    });
  }

  private addVariantCircularGeofences() {
    if (this.circularGeofences === null) return;

    this.circularGeofences.forEach(({ circle, marker }) => {
      this.map.addLayer(circle);
      if (marker !== null) {
        this.map.addLayer(marker);
      }
    });
  }
  private removeVariantCircularGeofences() {
    if (this.circularGeofences === null) return;

    this.circularGeofences.forEach(({ circle, marker }) => {
      this.map.removeLayer(circle);
      if (marker !== null) {
        this.map.removeLayer(marker);
      }
    });
  }

  private addVariantGeopoints() {
    if (this.geopoints === null) return;

    this.geopoints.forEach(({ markerGeopoint, markerName }) => {
      this.map.addLayer(markerGeopoint);
      if (markerName !== null) {
        this.map.addLayer(markerName);
      }
    });
  }
  private removeVariantGeopoints() {
    if (this.geopoints === null) return;

    this.geopoints.forEach(({ markerGeopoint, markerName }) => {
      this.map.removeLayer(markerGeopoint);
      if (markerName !== null) {
        this.map.removeLayer(markerName);
      }
    });
  }

  restoreDefaultSettings() {
    this.settings = {
      ...this.stateSettingsHistoryDrawerService.getCurrentConfig(),
    };
    this.saveSettings();
  }

  recreateHistory() {
    this.displayDialogSettings = false;
    this.displayDialogCustomHistory = true;
  }

  setLastValuesSettings() {
    this.settings = { ...this.lastSettings };
  }

  private hiddenDialogs() {
    this.displayDialogSettings = false;
    this.displayDialogCustomHistory = false;
    this.displayDialogDashboard = false;
    this.displayDialog = false;
  }

  private formatTimeToString(date: Date | string | null | undefined): string {
    if (!date) return '00:00:00';

    // Si es un string, devolverlo directamente (asumiendo formato HH:mm:ss)
    if (typeof date === 'string') {
      return date;
    }

    // Si es un objeto Date, extraer horas, minutos y segundos
    if (date instanceof Date && !isNaN(date.getTime())) {
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      const seconds = date.getSeconds().toString().padStart(2, '0');
      return `${hours}:${minutes}:${seconds}`;
    }

    // Si no es un Date válido, devolver valor por defecto
    return '00:00:00';
  }

  /**
   * Gestiona la visualización de frames basado en el nivel de zoom y área visible.
   * Implementa un algoritmo inteligente para mostrar solo los frames relevantes,
   * manteniendo los ya renderizados y añadiendo nuevos según sea necesario.
   *
   * @param history Historial con los frames a mostrar
   * @param settings Configuración del historial
   * @param zoom Nivel de zoom actual
   */
  private managerZoomend(
    history: StoreHistory,
    settings: SettingsHistoryDrawer,
    zoom: number
  ) {
    if (!history || !history.detailsHistory || !history.detailsHistory.frames) {
      return;
    }

    const framesData = history.detailsHistory.frames;
    console.log('(HISTORY) Actualizando frames, zoom:', zoom);

    // Si no estamos en la sección frames o si no está configurado, no hacemos nada
    if (this.currentItemAside !== 'frames' && !this.settings.showFrames) {
      return;
    }

    // En zoom <= 8, no mostramos ningún frame
    if (zoom <= 8) {
      this.removeVariantFrames(settings, history);
      this.renderedFrameIds.clear();
      this.zoomFrameMap.clear();
      console.log('(HISTORY) Zoom ≤ 8: Removiendo todos los frames');
      return;
    }

    // Para zoom 9-10, usamos una selección estática limitada a exactamente 30 frames
    if (zoom >= 9 && zoom <= 10) {
      // Solo renderizamos si no hay frames renderizados en este rango de zoom
      // o si venimos de otro rango de zoom
      if (
        this.renderedFrameIds.size === 0 ||
        (this.lastZoom && (this.lastZoom < 9 || this.lastZoom > 10))
      ) {
        // Limpiamos los frames existentes para asegurar consistencia
        this.removeVariantFrames(settings, history);
        this.renderedFrameIds.clear();

        // Renderizamos los frames estáticos para este rango de zoom
        this.renderStaticLowZoomFrames(history, settings);
        console.log('(HISTORY) Zoom 9-10: Renderizando frames estáticos');
      } else {
        console.log(
          '(HISTORY) Zoom 9-10: Manteniendo frames estáticos existentes'
        );
      }
      return;
    }

    // En zoom máximo (>=18), mostramos todos los frames y desactivamos el renderizado dinámico
    if (zoom >= 18) {
      this.renderAllFrames(history, settings);
      return;
    }

    // Para los demás niveles de zoom, usamos el algoritmo adaptativo
    this.renderAdaptiveFrames(history, settings, zoom);
  }

  /**
   * Renderiza todos los frames sin filtrado (para zoom alto)
   */
  private renderAllFrames(
    history: StoreHistory,
    settings: SettingsHistoryDrawer
  ) {
    // Limpiar los frames existentes para asegurar que se muestran todos correctamente
    this.removeVariantFrames(settings, history);

    // Añadir todos los frames originales
    this.addVariantFrames(settings, history);

    // Registrar todos los IDs como renderizados
    this.renderedFrameIds.clear();

    // Guardar los frames renderizados para este nivel de zoom
    const zoomFrames = new Set<number>();

    history.detailsHistory.frames.forEach((_, index) => {
      this.renderedFrameIds.add(index);
      zoomFrames.add(index);
    });

    // Guardar los frames por nivel de zoom
    this.zoomFrameMap.set(this.lastZoom, zoomFrames);

    console.log(
      '(HISTORY) Renderizados todos los frames:',
      this.renderedFrameIds.size
    );
  }

  /**
   * Implementa el algoritmo adaptativo para mostrar frames según el zoom y área visible
   */
  private renderAdaptiveFrames(
    history: StoreHistory,
    settings: SettingsHistoryDrawer,
    zoom: number
  ) {
    const framesData = history.detailsHistory.frames;
    const bounds = this.map.getBounds();

    // Verificar si hubo un cambio de zoom
    const isZoomChange = zoom !== this.lastZoom;

    // Para zoom entre 9-10, mantenemos un máximo estricto de frames por vista
    // y no añadimos más al hacer panning si ya alcanzamos el límite
    const isLowZoom = zoom >= 9 && zoom <= 10;

    // Si estamos en zoom bajo (9-10) y ya tenemos suficientes frames renderizados,
    // no hacemos nada más durante el panning
    if (
      isLowZoom &&
      !isZoomChange &&
      this.renderedFrameIds.size >= this.maxFramesPerView
    ) {
      console.log(
        '(HISTORY) Zoom 9-10: Ya se alcanzó el máximo de frames permitidos, manteniendo estado actual'
      );
      return;
    }

    // Obtener frames que están en el viewport actual
    const framesInView = this.getFramesInViewport(framesData, bounds);
    if (framesInView.length === 0) return;

    // Si es un cambio de zoom o estamos en zoom bajo, podemos necesitar limpiar frames
    if (isZoomChange || isLowZoom) {
      // Para zoom bajo (9-10), siempre limitamos estrictamente a maxFramesPerView
      // Sin importar si ya hay frames renderizados
      if (isLowZoom) {
        this.removeVariantFrames(settings, history);
        this.renderedFrameIds.clear();
      }
    }

    // Seleccionar frames según el algoritmo progresivo y la disponibilidad
    let selectedFrames = this.selectProgressiveFrames(framesInView, zoom);

    // Para zoom bajo (9-10), siempre limitamos estrictamente a maxFramesPerView
    if (isLowZoom) {
      // Limitar estrictamente a maxFramesPerView
      selectedFrames = selectedFrames.slice(0, this.maxFramesPerView);
      console.log(
        '(HISTORY) Zoom 9-10: Limitando estrictamente a',
        selectedFrames.length,
        'frames'
      );
    }

    // Filtrar solo los frames que aún no están renderizados
    const newFramesToRender = selectedFrames.filter(
      (frame) => !this.renderedFrameIds.has(frame.originalIndex)
    );

    console.log(
      '(HISTORY) Nuevos frames a renderizar:',
      newFramesToRender.length
    );

    if (newFramesToRender.length > 0) {
      // Crear un conjunto para almacenar los frames renderizados en este nivel de zoom
      let zoomFrames = this.zoomFrameMap.get(zoom) || new Set<number>();

      const tempHistory = this.createTempHistoryWithFrames(
        history,
        newFramesToRender
      );

      // Añadir solo los nuevos frames sin eliminar los existentes
      this.addVariantFramesPreserving(settings, tempHistory);

      // Registrar los nuevos frames como renderizados
      newFramesToRender.forEach((frame) => {
        this.renderedFrameIds.add(frame.originalIndex);
        zoomFrames.add(frame.originalIndex);
      });

      // Actualizar el mapa de frames por nivel de zoom
      this.zoomFrameMap.set(zoom, zoomFrames);
    }

    console.log(
      '(HISTORY) Total frames renderizados:',
      this.renderedFrameIds.size
    );
  }

  /**
   * Obtiene los frames que están dentro del viewport actual
   */
  private getFramesInViewport(
    frames: FrameHistoryAdapted[],
    bounds: L.LatLngBounds
  ): Array<FrameHistoryAdapted & { originalIndex: number }> {
    // Expandir los límites ligeramente para incluir frames cercanos al borde
    const expandedBounds = bounds.pad(0.2); // 20% más grande

    return frames
      .map((frame, index) => ({ ...frame, originalIndex: index }))
      .filter((frame) => {
        if (!frame.latitude || !frame.longitude) return false;
        return expandedBounds.contains(
          L.latLng(frame.latitude, frame.longitude)
        );
      });
  }

  /**
   * Selecciona frames usando un algoritmo progresivo basado en el zoom
   * Implementa la lógica 1->3->9->27->81 dependiendo del nivel de zoom
   */
  private selectProgressiveFrames(
    framesInView: Array<FrameHistoryAdapted & { originalIndex: number }>,
    zoom: number
  ): Array<FrameHistoryAdapted & { originalIndex: number }> {
    // Siempre incluir el primer y último frame
    const firstFrame = framesInView[0];
    const lastFrame = framesInView[framesInView.length - 1];

    // Determinar el factor de selección según el zoom
    // A mayor zoom, más frames mostramos
    let selectionStep: number;

    // Para zoom bajo (9-10), usamos una lógica especial de selección
    const isLowZoom = zoom >= 9 && zoom <= 10;

    // Progresión exponencial de frames según zoom
    if (zoom >= 16) {
      selectionStep = 3; // Alta densidad
    } else if (zoom >= 14) {
      selectionStep = 9; // Media densidad
    } else if (zoom >= 12) {
      selectionStep = 27; // Baja densidad
    } else if (zoom >= 10) {
      selectionStep = 81; // Muy baja densidad
    } else {
      selectionStep = 243; // Densidad mínima
    }

    // Calcular el número deseado de frames
    let desiredFrameCount: number;

    // Para zoom 9-10, aplicamos estrictamente el límite máximo
    if (isLowZoom) {
      desiredFrameCount = Math.min(this.maxFramesPerView, framesInView.length);
      console.log(
        '(HISTORY) Zoom bajo: Limitando a',
        desiredFrameCount,
        'frames'
      );
    } else {
      // Para otros niveles de zoom, usamos la fórmula progresiva
      desiredFrameCount = Math.min(
        Math.ceil(framesInView.length / selectionStep),
        framesInView.length
      );
    }

    // Si hay pocos frames o necesitamos mostrar todos, devolverlos directamente
    if (desiredFrameCount >= framesInView.length) {
      return framesInView;
    }

    // Seleccionar frames distribuidos uniformemente a lo largo de la ruta
    const selectedFrames: Array<
      FrameHistoryAdapted & { originalIndex: number }
    > = [firstFrame];

    // Para zoom bajo (9-10), usamos una selección simplificada para mantener
    // un máximo estricto y constante de frames
    if (isLowZoom) {
      // Selección equidistante para zoom bajo
      const step = Math.max(
        1,
        Math.floor(framesInView.length / (desiredFrameCount - 2))
      );

      for (let i = step; i < framesInView.length - step; i += step) {
        if (selectedFrames.length < desiredFrameCount - 1) {
          selectedFrames.push(framesInView[i]);
        }
      }
    } else {
      // Para otros niveles de zoom, usar la lógica completa

      // Seleccionar frames importantes (cambios de velocidad, dirección, etc.)
      const importantFrames = this.findImportantFrames(framesInView);
      selectedFrames.push(...importantFrames);

      // Si aún no alcanzamos el número deseado, añadir frames uniformemente distribuidos
      if (selectedFrames.length < desiredFrameCount) {
        const regularFrames = this.selectRegularFrames(
          framesInView,
          selectedFrames,
          desiredFrameCount - selectedFrames.length
        );
        selectedFrames.push(...regularFrames);
      }
    }

    // Asegurar que el último frame esté incluido
    if (!selectedFrames.includes(lastFrame)) {
      selectedFrames.push(lastFrame);
    }

    // Verificar si hay demasiados frames seleccionados (para zoom bajo)
    if (isLowZoom && selectedFrames.length > desiredFrameCount) {
      // Mantener el primer y último frame y seleccionar el resto uniformemente
      const result = [firstFrame];
      const middle = selectedFrames.slice(1, -1);
      const middleStep = Math.max(
        1,
        Math.floor(middle.length / (desiredFrameCount - 2))
      );

      for (let i = 0; i < middle.length; i += middleStep) {
        if (result.length < desiredFrameCount - 1) {
          result.push(middle[i]);
        }
      }

      result.push(lastFrame);
      console.log(
        '(HISTORY) Ajustando para zoom bajo, frames finales:',
        result.length
      );
      return result;
    }

    console.log('(HISTORY) Frames seleccionados:', selectedFrames.length);
    return selectedFrames;
  }

  /**
   * Encuentra frames importantes basados en cambios de velocidad, dirección, etc.
   * Utiliza total_distance_km para identificar puntos estratégicos de la ruta
   */
  private findImportantFrames(
    frames: Array<FrameHistoryAdapted & { originalIndex: number }>
  ): Array<FrameHistoryAdapted & { originalIndex: number }> {
    if (frames.length <= 2) return [];

    const importantFrames: Array<
      FrameHistoryAdapted & { originalIndex: number }
    > = [];
    const totalDistance =
      this.currentHistory?.detailsHistory?.total_distance_km || 0;

    // Si conocemos la distancia total, usamos esta información para calcular puntos estratégicos
    // a lo largo de la ruta (cada 25% del recorrido)
    if (totalDistance > 0) {
      // Determinar puntos aproximados de distribución del recorrido (25%, 50%, 75%)
      const quarterPoint = Math.floor(frames.length * 0.25);
      const halfPoint = Math.floor(frames.length * 0.5);
      const threeQuarterPoint = Math.floor(frames.length * 0.75);

      // Añadir estos puntos estratégicos si no están demasiado cerca de los extremos
      if (quarterPoint > 1) importantFrames.push(frames[quarterPoint]);
      if (halfPoint > quarterPoint + 1 && halfPoint < threeQuarterPoint - 1)
        importantFrames.push(frames[halfPoint]);
      if (threeQuarterPoint < frames.length - 2)
        importantFrames.push(frames[threeQuarterPoint]);
    }

    for (let i = 1; i < frames.length - 1; i++) {
      const prevFrame = frames[i - 1];
      const currentFrame = frames[i];
      const nextFrame = frames[i + 1];

      // Detectar paradas (velocidad 0)
      if (currentFrame.speed === 0) {
        importantFrames.push(currentFrame);
        continue;
      }

      // Detectar cambios significativos de velocidad (>20 km/h)
      const speedChangePrev = Math.abs(currentFrame.speed - prevFrame.speed);
      const speedChangeNext = Math.abs(currentFrame.speed - nextFrame.speed);
      if (speedChangePrev > 20 || speedChangeNext > 20) {
        importantFrames.push(currentFrame);
        continue;
      }

      // Detectar cambios significativos de dirección (>30 grados)
      const dirChangePrev = Math.abs(
        currentFrame.direction - prevFrame.direction
      );
      const dirChangeNext = Math.abs(
        currentFrame.direction - nextFrame.direction
      );
      if (dirChangePrev > 30 || dirChangeNext > 30) {
        importantFrames.push(currentFrame);
        continue;
      }
    }

    // Eliminar duplicados (si hay alguno)
    return [...new Set(importantFrames)];
  }

  /**
   * Selecciona frames distribuidos uniformemente a lo largo de la ruta
   */
  private selectRegularFrames(
    allFrames: Array<FrameHistoryAdapted & { originalIndex: number }>,
    alreadySelected: Array<FrameHistoryAdapted & { originalIndex: number }>,
    count: number
  ): Array<FrameHistoryAdapted & { originalIndex: number }> {
    // Filtrar frames que ya están seleccionados
    const remainingFrames = allFrames.filter(
      (frame) =>
        !alreadySelected.some((f) => f.originalIndex === frame.originalIndex)
    );

    if (remainingFrames.length <= count) {
      return remainingFrames;
    }

    const result: Array<FrameHistoryAdapted & { originalIndex: number }> = [];
    const step = Math.max(1, Math.floor(remainingFrames.length / count));

    for (
      let i = 0;
      i < remainingFrames.length && result.length < count;
      i += step
    ) {
      result.push(remainingFrames[i]);
    }

    return result;
  }

  /**
   * Crea un historial temporal solo con los frames seleccionados
   */
  private createTempHistoryWithFrames(
    originalHistory: StoreHistory,
    selectedFrames: Array<FrameHistoryAdapted & { originalIndex: number }>
  ): StoreHistory {
    // Crear una copia superficial del historial original
    const tempHistory = { ...originalHistory };

    // Crear copias de las propiedades que necesitamos modificar
    tempHistory.circleMarkers = [];
    tempHistory.variantsFrameMarkers = {
      speed: [],
      time: [],
      speedTime: [],
    };

    // Para cada frame seleccionado, copiar los markers correspondientes
    selectedFrames.forEach((frame) => {
      const index = frame.originalIndex;

      // Copiar markers según variante
      if (index < originalHistory.circleMarkers.length) {
        tempHistory.circleMarkers.push(originalHistory.circleMarkers[index]);
      }

      if (originalHistory.variantsFrameMarkers) {
        if (index < originalHistory.variantsFrameMarkers.speed.length) {
          tempHistory.variantsFrameMarkers.speed.push(
            originalHistory.variantsFrameMarkers.speed[index]
          );
        }

        if (index < originalHistory.variantsFrameMarkers.time.length) {
          tempHistory.variantsFrameMarkers.time.push(
            originalHistory.variantsFrameMarkers.time[index]
          );
        }

        if (index < originalHistory.variantsFrameMarkers.speedTime.length) {
          tempHistory.variantsFrameMarkers.speedTime.push(
            originalHistory.variantsFrameMarkers.speedTime[index]
          );
        }
      }
    });

    return tempHistory;
  }

  /**
   * Añade frames al mapa preservando los ya existentes
   */
  private addVariantFramesPreserving(
    settings: SettingsHistoryDrawer,
    history: StoreHistory
  ) {
    const variant = settings.frameVariant;

    switch (variant) {
      case 'basic':
        history.circleMarkers.forEach((circle) => {
          this.map.addLayer(circle);
        });
        break;
      case 'speed':
        history.variantsFrameMarkers?.speed.forEach((marker) => {
          this.map.addLayer(marker);
        });
        break;
      case 'time':
        history.variantsFrameMarkers?.time.forEach((marker) => {
          this.map.addLayer(marker);
        });
        break;
      case 'speed-time':
        history.variantsFrameMarkers?.speedTime.forEach((marker) => {
          this.map.addLayer(marker);
        });
        break;
    }
  }

  /**
   * Limpia los frames específicos para la reducción de zoom
   * Esta función elimina del mapa los frames que ya no deberían ser visibles
   * al reducir el nivel de zoom
   */
  private clearFramesForZoomOut(
    history: StoreHistory,
    settings: SettingsHistoryDrawer,
    prevZoom: number,
    newZoom: number
  ) {
    // Si no hay información sobre los frames por nivel de zoom, no podemos hacer nada
    if (!this.zoomFrameMap.has(prevZoom)) {
      // Limpiar todo y empezar de nuevo
      this.removeVariantFrames(settings, history);
      this.renderedFrameIds.clear();
      return;
    }

    // Obtener los frames que estaban visibles en el zoom anterior
    const prevZoomFrames = this.zoomFrameMap.get(prevZoom) || new Set<number>();

    // Limpiar el conjunto actual de frames renderizados
    this.renderedFrameIds.clear();

    // Eliminar específicamente los frames del zoom anterior
    for (const frameIndex of prevZoomFrames) {
      // Eliminar el frame específico del mapa
      this.removeSpecificFrame(settings, history, frameIndex);
    }

    // Limpiar la información de frames para este nivel de zoom
    this.zoomFrameMap.delete(prevZoom);

    console.log(
      '(HISTORY) Frames eliminados al reducir zoom:',
      prevZoomFrames.size
    );
  }

  /**
   * Elimina un frame específico del mapa
   */
  private removeSpecificFrame(
    settings: SettingsHistoryDrawer,
    history: StoreHistory,
    frameIndex: number
  ) {
    const variant = settings.frameVariant;

    switch (variant) {
      case 'basic':
        if (frameIndex < history.circleMarkers.length) {
          this.map.removeLayer(history.circleMarkers[frameIndex]);
        }
        break;
      case 'speed':
        if (
          history.variantsFrameMarkers?.speed &&
          frameIndex < history.variantsFrameMarkers.speed.length
        ) {
          this.map.removeLayer(history.variantsFrameMarkers.speed[frameIndex]);
        }
        break;
      case 'time':
        if (
          history.variantsFrameMarkers?.time &&
          frameIndex < history.variantsFrameMarkers.time.length
        ) {
          this.map.removeLayer(history.variantsFrameMarkers.time[frameIndex]);
        }
        break;
      case 'speed-time':
        if (
          history.variantsFrameMarkers?.speedTime &&
          frameIndex < history.variantsFrameMarkers.speedTime.length
        ) {
          this.map.removeLayer(
            history.variantsFrameMarkers.speedTime[frameIndex]
          );
        }
        break;
    }
  }

  /**
   * Renderiza un conjunto fijo de frames para los niveles de zoom 9-10
   * Estos frames permanecerán estáticos y no se modificarán durante el paneo
   * ni durante pequeños cambios de zoom dentro de este rango.
   */
  private renderStaticLowZoomFrames(
    history: StoreHistory,
    settings: SettingsHistoryDrawer
  ) {
    if (!history || !history.detailsHistory || !history.detailsHistory.frames) {
      return;
    }

    console.log('(HISTORY) Renderizando frames estáticos para zoom 9-10');

    const framesData = history.detailsHistory.frames;
    const totalFrames = framesData.length;

    // Siempre incluir el primer y último frame
    const firstFrame = framesData[0];
    const lastFrame = framesData[totalFrames - 1];

    // Seleccionar frames distribuidos uniformemente a lo largo de la ruta
    // hasta un máximo de maxFramesPerView
    const selectedFrames: Array<{ frame: FrameHistoryAdapted; index: number }> =
      [{ frame: firstFrame, index: 0 }];

    // Usar la información de total_distance_km para calcular puntos estratégicos
    const totalDistance = history.detailsHistory.total_distance_km || 0;

    // Seleccionar puntos estratégicos de la ruta (25%, 50%, 75%)
    if (totalDistance > 0 && totalFrames > 3) {
      const quarterIndex = Math.floor(totalFrames * 0.25);
      const halfIndex = Math.floor(totalFrames * 0.5);
      const threeQuarterIndex = Math.floor(totalFrames * 0.75);

      selectedFrames.push({
        frame: framesData[quarterIndex],
        index: quarterIndex,
      });
      selectedFrames.push({ frame: framesData[halfIndex], index: halfIndex });
      selectedFrames.push({
        frame: framesData[threeQuarterIndex],
        index: threeQuarterIndex,
      });
    }

    // Añadir más frames distribuidos uniformemente hasta llegar al límite
    const remainingSlots = this.maxFramesPerView - selectedFrames.length - 1; // -1 para reservar espacio para el último frame

    if (remainingSlots > 0 && totalFrames > 5) {
      const step = Math.max(1, Math.floor(totalFrames / (remainingSlots + 2))); // +2 para tener en cuenta el primer y último frame

      // Seleccionar frames distribuidos uniformemente
      for (let i = step; i < totalFrames - step; i += step) {
        // Verificar que no sea uno de los frames estratégicos ya añadidos
        if (
          !selectedFrames.some((item) => item.index === i) &&
          selectedFrames.length < this.maxFramesPerView - 1
        ) {
          selectedFrames.push({ frame: framesData[i], index: i });
        }
      }
    }

    // Añadir el último frame si no está ya incluido
    if (!selectedFrames.some((item) => item.index === totalFrames - 1)) {
      selectedFrames.push({ frame: lastFrame, index: totalFrames - 1 });
    }

    // Crear un historial temporal con los frames seleccionados
    const tempHistory = this.createStaticTempHistory(history, selectedFrames);

    // Añadir los frames al mapa
    this.addVariantFrames(settings, tempHistory);

    // Registrar los frames como renderizados
    selectedFrames.forEach((item) => {
      this.renderedFrameIds.add(item.index);
    });

    console.log(
      '(HISTORY) Frames estáticos renderizados:',
      selectedFrames.length
    );
  }

  /**
   * Crea un historial temporal para los frames estáticos en zoom bajo
   */
  private createStaticTempHistory(
    originalHistory: StoreHistory,
    selectedFrames: Array<{ frame: FrameHistoryAdapted; index: number }>
  ): StoreHistory {
    // Crear una copia superficial del historial original
    const tempHistory = { ...originalHistory };

    // Crear copias de las propiedades que necesitamos modificar
    tempHistory.circleMarkers = [];
    tempHistory.variantsFrameMarkers = {
      speed: [],
      time: [],
      speedTime: [],
    };

    // Para cada frame seleccionado, copiar los markers correspondientes
    selectedFrames.forEach((item) => {
      const index = item.index;

      // Copiar markers según variante
      if (index < originalHistory.circleMarkers.length) {
        tempHistory.circleMarkers.push(originalHistory.circleMarkers[index]);
      }

      if (originalHistory.variantsFrameMarkers) {
        if (index < originalHistory.variantsFrameMarkers.speed.length) {
          tempHistory.variantsFrameMarkers.speed.push(
            originalHistory.variantsFrameMarkers.speed[index]
          );
        }

        if (index < originalHistory.variantsFrameMarkers.time.length) {
          tempHistory.variantsFrameMarkers.time.push(
            originalHistory.variantsFrameMarkers.time[index]
          );
        }

        if (index < originalHistory.variantsFrameMarkers.speedTime.length) {
          tempHistory.variantsFrameMarkers.speedTime.push(
            originalHistory.variantsFrameMarkers.speedTime[index]
          );
        }
      }
    });

    return tempHistory;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.managerVehicleHistoryDrawerService.deleteAllHistories();
    // Limpiar el estado de las tarjetas seleccionadas
    this.stateHistoryCardsService.clearAllCards();
    // Limpiar la memoria de frames renderizados
    this.renderedFrameIds.clear();
    // Limpiar el mapa de frames por zoom
    this.zoomFrameMap.clear();
  }
}
